import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
// COMPONENTS
import Select from 'react-select';
import Chart from 'react-google-charts';
import BlockUi from 'react-block-ui';
import { Form, Spinner, Modal } from 'react-bootstrap';
import Flatpickr from "react-flatpickr";
// ICONS
import { HiChevronRight } from 'react-icons/hi';
import { BiSearchAlt2 } from 'react-icons/bi';
// CUSTOM COMPONENTS
import CustomBlock from '../../../components/CustomBlock';
import Button from '../../../components/Button';
import ContentHeader from '../../../components/ContentHeader';
// SERVICES AND HELPERS
import * as dashboardService from '../../../../services/dashboard/dashboardService';
import * as jobService from '../../../../services/service/jobService';

const defaultFilters = {
    start: "01/01/" + (new Date().getFullYear()),
    end: moment().format('L'),
    jobId: null
};

const JobFinancialsSnapShotBlock = (props) => {
    const { auth } = props;
    const startDate = localStorage.getItem('startDate');
    const endDate = localStorage.getItem('endDate');
    const [loading, setLoading] = useState(false);
    const [financialData, setFinancialData] = useState([]);
    const [jobs, setJobs] = useState([]);
    const [jobIdSelected, setJobIdSelected] = useState(0);
    const [filters, setFilters] = useState({ ...defaultFilters, start: startDate ? startDate : defaultFilters.start, end: endDate ? endDate : defaultFilters.end });
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        getJobFinanicalsData();
    }, []);

    const getJobFinanicalsData = () => {
        setLoading(true);
        const isAdmin = auth && auth.user && (auth.user.username === 'admin' || auth.user.username === 'Chip');
        dashboardService.getJobFinanicals(filters).then(res => {
            let tempArr = [['Projects - ' + (filters.start) + ' to ' + (filters.end), 'Annual Quota', 'Revenue', 'Target', 'Actual']];
            if (isAdmin) {
                tempArr[0].push('Distributed Admin');
            }
            res.forEach(x => {
                const dataRow = [
                    x.name,
                    x.annualQuota,
                    x.revenue,
                    x.target,
                    x.actual
                ];
                if (isAdmin) {
                    dataRow.push(x.distributedAdminCosts);
                }
                tempArr.push(dataRow);
            });
            setFinancialData(tempArr);
        }).catch(ex => { })
            .finally(() => { setLoading(false) });
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const isAdmin = auth && auth.user && (auth.user.username === 'admin' || auth.user.username === 'Chip');

    return (
        <>
            <Modal centered size="xs" show={isModalOpen} onHide={handleModalClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Filter Financial Chart</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form">
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                Start Date
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <Flatpickr
                                        placeholder="MM/DD/YYYY"
                                        options={{
                                            enableTime: false,
                                            dateFormat: "m/d/Y",
                                            static: true
                                        }}
                                        value={filters.start}
                                        onChange={date => {
                                            setFilters({ ...filters, start: moment(date[0]).format("MM/DD/YYYY") });
                                            localStorage.setItem('startDate', moment(date[0]).format("MM/DD/YYYY"));
                                        }}
                                        className="form-control form-control-lg form-control-solid"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                End Date
                            </label>
                            <div className="col-lg-9 col-xl-9">
                                <div className="input-group input-group-lg input-group-solid">
                                    <Flatpickr
                                        placeholder="MM/DD/YYYY"
                                        options={{
                                            enableTime: false,
                                            dateFormat: "m/d/Y",
                                            static: true
                                        }}
                                        value={filters.end}
                                        onChange={date => {
                                            setFilters({ ...filters, end: moment(date[0]).format("MM/DD/YYYY") });
                                            localStorage.setItem('endDate', moment(date[0]).format("MM/DD/YYYY"));
                                        }}
                                        className="form-control form-control-lg form-control-solid"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        text={"Close"}
                        className="secondary--bg mr-0"
                        size="xxs"
                        onClick={handleModalClose}
                    />
                    <Button
                        text={"Filter"}
                        className="primary--bg mr-0"
                        size="xxs"
                        onClick={() => {
                            getJobFinanicalsData();
                            handleModalClose();
                        }}
                    />
                </Modal.Footer>
            </Modal>
            <BlockUi tag="div" blocking={loading}>
                <CustomBlock className="job-list-block-container h-100">
                    <CustomBlock className="job-list-block-header">
                        <CustomBlock className="header-block">
                            <CustomBlock>
                                <ContentHeader
                                    title="Snap Shot"
                                    headerSize="sm"
                                    textHeaderStyle="pb-0"
                                />
                            </CustomBlock>
                            <CustomBlock>
                                <Button
                                    text={"Filter"}
                                    className="primary--bg mr-0"
                                    size="xxs"
                                    onClick={() => { setIsModalOpen(true) }}
                                />
                            </CustomBlock>
                        </CustomBlock>
                        <CustomBlock>
                            <Chart
                                width={'100%'}
                                height={'340px'}
                                chartType="Bar"
                                loader={<div>Loading Chart</div>}
                                data={financialData}
                                options={{
                                    chart: {
                                        title: '',
                                        subtitle: ''
                                    },
                                    colors: isAdmin
                                        ? ['#f4b400', '#0f9d58', '#4285f4', '#db4437', '#ff6f61']
                                        : ['#f4b400', '#0f9d58', '#4285f4', '#db4437']
                                }}
                                formatters={[
                                    {
                                        type: "NumberFormat",
                                        column: 1,
                                        options: {
                                            prefix: "$",
                                            pattern: 'decimal',
                                            negativeColor: "red",
                                            negativeParens: true
                                        }
                                    },
                                    {
                                        type: "NumberFormat",
                                        column: 2,
                                        options: {
                                            prefix: "$",
                                            pattern: 'decimal',
                                            negativeColor: "red",
                                            negativeParens: true
                                        }
                                    },
                                    {
                                        type: "NumberFormat",
                                        column: 3,
                                        options: {
                                            prefix: "$",
                                            pattern: 'decimal',
                                            negativeColor: "red",
                                            negativeParens: true
                                        }
                                    },
                                    {
                                        type: "NumberFormat",
                                        column: 4,
                                        options: {
                                            prefix: "$",
                                            pattern: 'decimal',
                                            negativeColor: "red",
                                            negativeParens: true
                                        }
                                    },
                                    ...(isAdmin ? [{
                                        type: "NumberFormat",
                                        column: 5,
                                        options: {
                                            prefix: "$",
                                            pattern: 'decimal',
                                            negativeColor: "red",
                                            negativeParens: true
                                        }
                                    }] : [])
                                ]}
                                rootProps={{ 'data-testid': '2' }}
                            />
                        </CustomBlock>
                    </CustomBlock>
                </CustomBlock>
            </BlockUi>
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps)(JobFinancialsSnapShotBlock);